export default "__VITE_ASSET__CLjiKxno__"